import { lazy, Suspense, useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { hasCamera, primeAudio } from "@/lib/cameraScan";

const CameraOverlay = lazy(() => import(/* webpackChunkName: "camera-scanner" */ "@/components/scan/CameraOverlay"));

export function useHasCamera() {
  const [ok, setOk] = useState(false);
  useEffect(() => {
    let live = true;
    hasCamera().then((v) => live && setOk(v));
    return () => { live = false; };
  }, []);
  return ok;
}

/**
 * Camera button + lazy full-screen overlay.
 * onDetect(code) → {ok, label, action?} | Promise of it. continuous=false closes after one detection.
 */
export function CameraScanButton({ onDetect, continuous = false, title = "Scan with camera", status, testid = "camera-scan-button", className = "", disabled = false }) {
  const can = useHasCamera();
  const [open, setOpen] = useState(false);
  if (!can) return null;
  return (
    <>
      <button type="button" disabled={disabled} onClick={() => { primeAudio(); setOpen(true); }} data-testid={testid} aria-label={title} title={title}
        className={`grid shrink-0 place-items-center rounded-xl border border-slate-200 bg-white text-slate-700 transition-colors hover:border-slate-900 disabled:opacity-40 ${className || "h-12 w-12"}`}>
        <Camera className="h-5 w-5" />
      </button>
      {open && (
        <Suspense fallback={<div className="fixed inset-0 z-[80] bg-black" data-testid="camera-overlay-loading" />}>
          <CameraOverlay title={title} continuous={continuous} onDetect={onDetect} status={status} onClose={() => setOpen(false)} />
        </Suspense>
      )}
    </>
  );
}
